import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import pl from 'date-fns/locale/pl';

registerLocale('pl', pl);
setDefaultLocale('pl');

class Datepicker extends PureComponent {
  onChange = (date) => {
    const { id, onChange } = this.props;

    onChange(id, date);
  };

  render() {
    const {
      label,
      id,
      onChange,
      value,
      ...rest
    } = this.props;

    return (
      <div className="row form-group">
        <div className="col col-md-3">
          <label htmlFor={id} className="form-control-label">
            {label}
          </label>
        </div>
        <div className="col-12 col-md-9">
          <DatePicker
            selected={value}
            onChange={this.onChange}
            dateFormat="P"
            {...rest}
          />
        </div>
      </div>
    );
  }
}

Datepicker.defaultProps = {
  label: '',
  value: '',
};

Datepicker.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default Datepicker;
